const dropdownListHeight = {
  small: 186,
  medium: 228,
  large: 268
};
const getDropdownDirection = (bottom, size) => {
  return window.innerHeight - bottom < dropdownListHeight[size] ? 'up' : 'down';
};

export { getDropdownDirection as g };
